/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Same_Smart_Shark_CareInputs */

const en_same_smart_shark_care = /** @type {(inputs: Same_Smart_Shark_CareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No attributes found`)
};

const de_same_smart_shark_care = /** @type {(inputs: Same_Smart_Shark_CareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Merkmale gefunden`)
};

/**
* | output |
* | --- |
* | "No attributes found" |
*
* @param {Same_Smart_Shark_CareInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const same_smart_shark_care = /** @type {((inputs?: Same_Smart_Shark_CareInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Same_Smart_Shark_CareInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_same_smart_shark_care(inputs)
	return de_same_smart_shark_care(inputs)
});